import { AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery } from '@festina/unitlink-general-types/unitlink/hooks/AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery'

export const useFetchAnnotationCommands =
  AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery.useSuspenseQuery
